import { Routes } from '@angular/router';
import { OrcamentaryPlanningComponent } from './pages/orcamentary-planning/pages/home/orcamentary-planning.component';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.routes').then((routes) => routes.ADMIN_ROUTES),
  },
  {
    path: 'ppa',
    loadChildren: () => import('./ppa/ppa.routes').then((m) => m.PPA_ROUTES),
  },
  {
    path: 'loa',
    loadChildren: () => import('./loa/loa.routes').then((m) => m.LOA_ROUTES),
  },
  {
    path: '',
    pathMatch: 'full',
    component: OrcamentaryPlanningComponent,
  },
  { path: '**', redirectTo: '' },
];
